import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
} from '@angular/core';
import { NgIf } from '@angular/common';
import {
  NzBreadCrumbComponent,
  NzBreadCrumbItemComponent
} from 'ng-zorro-antd/breadcrumb';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { PageHeaderComponent } from '@delon/abc/page-header';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ACLDirective } from '@delon/acl';

@Component({
  selector: 'app-import-excel-page-header',
  standalone: true,
  imports: [
    NgIf,
    NzBreadCrumbComponent,
    NzBreadCrumbItemComponent,
    NzButtonComponent,
    NzIconDirective,
    NzTooltipDirective,
    NzWaveDirective,
    PageHeaderComponent,
    RouterLink,
    ACLDirective
  ],
  templateUrl: './import-excel-page-header.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportExcelPageHeaderComponent implements OnInit {
  private route = inject(ActivatedRoute);

  loading = input<boolean>(false);
  deleting = input<boolean>(false);
  fieldMappingEnabled = input<boolean>(false);
  selectedRows = input<any[]>([]);
  breadcrumbs = input<IBreadcrumb[]>([]);
  pageTitle = input<string>('');

  @Output() requestSaveItems = new EventEmitter();
  @Output() requestFieldMapping = new EventEmitter();
  @Output() requestShowImportDrawer = new EventEmitter();
  @Output() requestDelete = new EventEmitter();

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.has('openDrawer')) {
      this.requestShowImportDrawer.emit();
    }
  }
}

export interface IBreadcrumb {
  label: string;
  link?: string;
}
